var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider hero__slider"},[_c('ul',{staticClass:"slider__list"},_vm._l((_vm.images),function(image,index){return _c('li',{key:index,staticClass:"slider__list-item"},[_c('img',{staticClass:"slider__image",attrs:{"src":image.url}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }